import React from 'react';
import Sidebar from '../../components/widgets/sidebar';
import SidebarBase from './Base';

export default class Admin extends SidebarBase {

  render() {
    return (
      <>
        <Sidebar.Item text="دستگاه" icon="fal fa-sensor">
          <Sidebar.Item path="/dashboard/create-device" text="دستگاه جدید" />
          <Sidebar.Item path="/dashboard/devices" text="لیست دستگاه ها" />
          <Sidebar.Item path="/dashboard/devices/edit/Default" text="دستگاه پیشفرض" />
          <Sidebar.Item path="/dashboard/unknown-devices" text="دستگاه‌های ناشناخته" />
        </Sidebar.Item>
        <Sidebar.Item text="کاربران" icon="fal fa-user">
          <Sidebar.Item path="/dashboard/create-user" text="کاربر جدید" />
          <Sidebar.Item path="/dashboard/users" text="لیست کاربران" />
        </Sidebar.Item>
        <Sidebar.Item path="/dashboard/collections" text="بانک اطلاعاتی" icon="fal fa-database" />
      </>
    );
  }

}
